import React from 'react'
import {
    AppBar,
    Toolbar,
    Box,
    List,
    ListItem,
    Typography, 
    styled,
    ListItemButton,
    ListItemText,
    Button
} from '@mui/material';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
// menu
import DrawerItem from './DrawerItem';
// rotas
import { Link } from 'react-router-dom';
import logo from '../assets/egress-jackson.webp';


// personalizacao
const StyledToolbar = styled(Toolbar) ({
    display: 'flex',
    justifyContent: 'space-between',
});

const ListMenu = styled(List)(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up("sm")] : {
        display: "flex",
    },
}));

//rotas
const itemList = [
    {
      text: "HOME",
      to: "/#" 
    },
    {
      text: "ABOUT",
      to: "/about#"
    },
    {
        text: "PRODUCTS",
        to: "/egress-window-products"
    },        
    {
        text: "EGRESS WINDOWS",
        to: "/egress-windows#"
    },
    {
        text: "BLOG",
        to: "/egress-blog"
    },   
    {
        text: "CONTACT",
        to: "/contact#"
    }
    
    
];


const Navbar = () => {
    
    return (
        <AppBar 
        component="nav" 
        position="fixed"
        sx={{ 
            backgroundColor: 'rgba(0,0,0,0.7)', 
            paddingRight: '10px',
            paddingLeft: '10px'
    
        }}
        elevation={1}
        >
            <StyledToolbar>
                <Typography
                variant="p"
                component="p"

                >
                    <img src={logo} alt="egress-window-company-logo" 
                style={{
                    width: '130px',
                    display: 'flex',
                    verticalAlign: 'middle'
                    
                    
                }}
                />
                </Typography>
                <Box sx={{display: { xs: 'block', sm: 'none' } }}>
                    <DrawerItem /> 
                </Box>
                <ListMenu>
                    {itemList.map( ( item ) => {
                        const { text } = item;
                        return(
                            <ListItem key={text}>
                                <ListItemButton component={Link} to={item.to}
                                sx={{
                                    color: '#fff',
                                    width: '10vw',
                                    textAlign: 'center',
                                    alignItems: 'center',
                                    justifyContent: 'space-evenly',
                                    fontSize: '0.5rem',
                                    
                                    "&:hover": {
                                        backgroundColor: '#00AD14',
                                        color: '#fff',
                                        borderRadius: 1,
                                        width: '10vw',
                                        textAlign: 'center'
                                    }
                                }}
                                >
                                    <ListItemText primary={text} sx={{fontSize: '0.5rem'}} />
                                </ListItemButton>
                            </ListItem>
                        )
                    })}
                </ListMenu>
                <div><a href='/stories'><Button width= '50px' height='50px' minWidth='50px' sx={{color: '#ffffff',  backgroundColor: '#00AD14', textDecoration: 'none', borderRadius: '40px', width: '20px', height: '35px', '@media (max-width:600px)': {
              display: 'none'
            }}}>
        <ViewCarouselIcon fontSize={'1.5rem'} sx={{color:'#ffffff', verticalAlign:'middle', fontSize: '1.5em'}}></ViewCarouselIcon>
        </Button>
        </a></div>
        <div><a href='/videos'>
        <Button width= '50px' minWidth='50px' sx={{color: '#ffffff', backgroundColor: '#00AD14', textDecoration: 'none',borderRadius: '40px', width: '20px', height: '35px','@media (max-width:600px)': {
              display: 'none'
            }}}>
        <PlayCircleIcon fontSize={'1.5rem'} sx={{color:'#ffffff', verticalAlign:'middle', fontSize: '1.5em'}} ></PlayCircleIcon>
        </Button>
        </a></div>
            </StyledToolbar>
        </AppBar>
    )
}

export default Navbar;
